import { ERecieveMethod, ITableOrder } from 'models/orders'
import { useYandexStation } from './useYandexStation'

// Откуда продавец везёт заказ: пункт записан в заказе, у старых заказов — только в профиле
// продавца. Пункт СДЭК лежит у продавца целиком, у Яндекса — только id
export const useOrderShipFromAddress = (order?: ITableOrder | null) => {
  const provider =
    order?.delivery_info?.provider ?? order?.pvz?.provider ?? 'CDEK'
  const isYandex = provider === 'YANDEX'
  const isPvz = order?.receive_method === ERecieveMethod.PVZ
  // Курьерскую доставку СДЭКа продавец тоже сдаёт в ПВЗ
  const isCdekCourier =
    order?.receive_method === ERecieveMethod.COURIER && !isYandex
  const orderPoint =
    order?.delivery_info?.shipment_point?.provider === provider
      ? order.delivery_info.shipment_point
      : undefined
  const { station } = useYandexStation(
    isPvz && isYandex && !orderPoint?.address
      ? orderPoint?.code ?? order?.seller_id?.yandex_dropoff_station_id
      : null
  )

  if (!isPvz && !isCdekCourier) return undefined
  if (orderPoint?.address) return orderPoint.address
  return isYandex
    ? station?.location.address_full ?? station?.location.address
    : order?.seller_id?.nearest_point_of_cdek?.location.address_full
}
